import React from 'react';
import { motion } from 'framer-motion';
import { Users, Shield, Award, CheckCircle2, Lock } from 'lucide-react';
export function RankProgression() {
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-285">
      <div className="px-6 py-5 border-b border-slate-200 flex items-center gap-3 bg-white" data-id="element-286">
        <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0" data-id="element-287">
          <Award size={20} data-id="element-288" />
        </div>
        <div data-id="element-289">
          <h2 className="text-base font-bold text-[#0a1e5e] uppercase tracking-wide" data-id="element-290">
            Career Progression
          </h2>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-291">
            Track your journey to Divisional Lead
          </p>
        </div>
      </div>

      <div className="p-6" data-id="element-292">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-293">
          {/* Tier 1 - Completed */}
          <div className="bg-white border-2 border-slate-200 rounded-xl p-5 relative opacity-70 flex flex-col h-full" data-id="element-294">
            <div className="absolute -top-3 -right-3 bg-white rounded-full p-1.5 border-2 border-slate-200 shadow-sm" data-id="element-295">
              <CheckCircle2 size={20} className="text-green-500" data-id="element-296" />
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-297">
              <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600" data-id="element-298">
                <Users size={20} data-id="element-299" />
              </div>
              <h3 className="font-bold text-slate-700 leading-tight" data-id="element-300">
                Developmental
                <br data-id="element-301" />
                Team Lead
              </h3>
            </div>
            <p className="text-xs text-slate-500" data-id="element-302">
              Train and develop new Loan Partners and Loan Officers.
            </p>
          </div>

          {/* Tier 2 - Current */}
          <motion.div initial={{
          y: 10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} className="bg-white border-2 border-[#0a1e5e] rounded-xl p-5 relative ring-2 ring-blue-100 ring-offset-2 ring-offset-white flex flex-col h-full" data-id="element-303">
            <div className="absolute -top-3 -right-3 bg-[#0a1e5e] text-white rounded-full px-3 py-1 text-xs font-bold border-2 border-white shadow-sm" data-id="element-304">
              CURRENT
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-305">
              <div className="w-10 h-10 rounded-full bg-[#0a1e5e] flex items-center justify-center text-white" data-id="element-306">
                <Shield size={20} data-id="element-307" />
              </div>
              <h3 className="font-bold text-[#0a1e5e] text-lg" data-id="element-308">Team Lead</h3>
            </div>
            <p className="text-xs text-slate-600 mb-4" data-id="element-309">
              Keep and grow your team. Lead your producers to consistent
              success.
            </p>

            <div className="bg-slate-50 rounded-lg p-3 border border-slate-200 mt-auto" data-id="element-310">
              <div className="flex justify-between text-xs font-bold text-slate-500 mb-1" data-id="element-311">
                <span data-id="element-312">Progress to Next Tier</span>
                <span className="text-blue-600" data-id="element-313">65%</span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-1.5 mb-2" data-id="element-314">
                <div className="bg-blue-600 h-1.5 rounded-full" style={{
                width: '65%'
              }} data-id="element-315"></div>
              </div>
              <p className="text-[10px] text-slate-500" data-id="element-316">
                8 of 12 months completed • 1.8/2.0 avg closings
              </p>
            </div>
          </motion.div>

          {/* Tier 3 - Locked */}
          <div className="bg-white border-2 border-slate-200 rounded-xl p-5 relative opacity-70 flex flex-col h-full" data-id="element-317">
            <div className="absolute -top-3 -right-3 bg-white rounded-full p-1.5 border-2 border-slate-200 shadow-sm" data-id="element-318">
              <Lock size={20} className="text-slate-400" data-id="element-319" />
            </div>
            <div className="flex items-center gap-3 mb-3" data-id="element-320">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600" data-id="element-321">
                <Award size={20} data-id="element-322" />
              </div>
              <h3 className="font-bold text-slate-700 text-lg" data-id="element-323">
                Divisional Lead
              </h3>
            </div>
            <p className="text-xs text-slate-500" data-id="element-324">
              Lead at a higher level. Grow your division and drive impact.
            </p>
          </div>
        </div>

        {/* Requirements Footer */}
        <div className="mt-6 pt-6 border-t border-slate-200" data-id="element-325">
          <div className="bg-orange-50 border border-orange-200 rounded-xl p-4" data-id="element-326">
            <div className="flex items-start gap-3" data-id="element-327">
              <div className="w-9 h-9 rounded-lg bg-orange-100 flex items-center justify-center text-orange-600 shrink-0" data-id="element-328">
                <Award size={18} data-id="element-329" />
              </div>
              <div data-id="element-330">
                <p className="text-xs font-bold text-orange-800 uppercase mb-1" data-id="element-331">
                  Requirements to become Divisional Lead
                </p>
                <p className="text-sm text-orange-900 font-medium" data-id="element-332">
                  Minimum 1 Year as Team Lead{' '}
                  <span className="font-bold" data-id="element-333">AND</span> Maintain an Average
                  Close of 2 Closings per LO/LP over an 8 Month Period.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}